module.exports = __webpack_public_path__ + "img/step1-b.fe6b28ad.png";